import { HttpClient } from "@angular/common/http";
import { Inject, Injectable, Optional } from "@angular/core";
import { ENVIRONMENT, Environment } from "@vattenfall/core";

import { CampaignProductCardFinland } from "./campaign-product-card-finland.model";

@Injectable({
  providedIn: "root",
})
export class CampaignProductCardFinlandService {
  constructor(
    private http: HttpClient,
    @Optional()
    @Inject(ENVIRONMENT)
    private environment: Environment
  ) {}
  public getCampaignProductCardFinland(productId: string, campaignCode = "") {
    const queryParameters = new URLSearchParams(
      Object.entries({
        languageCode: this.environment.language,
        campaignCode,
      }).filter(([_key, value]) => !!value)
    ).toString();
    return this.http.get<CampaignProductCardFinland>(
      `${this.environment.endpoints.finlandApi}/api/acquisition/products/${productId}?${queryParameters}`
    );
  }
}
